export const CookwareKitchenUtensils = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="22"
          y="21.5"
          width="20"
          height="8"
          rx="1"
          transform="rotate(-180 22 21.5)"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 13.5V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 10.5H18V13.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 5.5L2.4453 7.20313C2.1671 7.3886 2 7.70083 2 8.03518V9C2 9.27614 2.22386 9.5 2.5 9.5H11.5C11.7761 9.5 12 9.27614 12 9V8.03518C12 7.70083 11.8329 7.3886 11.5547 7.20313L9 5.5V4C9 3.72386 8.77614 3.5 8.5 3.5H5.5C5.22386 3.5 5 3.72386 5 4V5.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 16.5H2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div className="max-w-[150px] truncate">Cookware & Kitchen Utensils</div>
    </div>
  );
};

export const DryingRack = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 6V5C19 3.895 18.105 3 17 3V3C15.895 3 15 3.895 15 5V19C15 20.105 14.105 21 13 21H7C5.895 21 5 20.105 5 19V6C5 4.343 6.343 3 8 3H17"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 9V15C19 16.105 18.105 17 17 17H15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 9H20.5C21.328 9 22 8.328 22 7.5V7.5C22 6.672 21.328 6 20.5 6H15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 6H3.5C2.672 6 2 6.672 2 7.5V7.5C2 8.328 2.672 9 3.5 9H5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Drying Rack</div>
    </div>
  );
};

export const CableTv = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="4"
          y="3"
          width="16"
          height="9"
          rx="1"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 15V12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 12V15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 21V16C2 15.4477 2.44772 15 3 15H21C21.5523 15 22 15.4477 22 16V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 19H2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 21V19"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div> Cable Tv</div>
    </div>
  );
};

export const Toaster = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.0039 12.5002H23.0047"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.99734 9.49878H18.0023C19.6599 9.49878 21.0036 10.8425 21.0036 12.5V19.5029C21.0036 20.608 20.1078 21.5038 19.0028 21.5038H4.99693C3.8919 21.5038 2.99609 20.608 2.99609 19.5029V12.5C2.99609 10.8425 4.3398 9.49878 5.99734 9.49878Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99805 15.5014H8.9993"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0036 18.5026H2.99609"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.49805 9.49877V4.49668C6.49805 3.39165 7.39385 2.49585 8.49888 2.49585H15.5018C16.6068 2.49585 17.5026 3.39165 17.5026 4.49668V9.49877"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99923 5.24707V6.7477"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0012 5.24707V6.7477"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Toaster</div>
    </div>
  );
};

export const Wardrobe = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.00006 9H7.00003"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.00006 15H7.00003"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.00003 21V3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 21V3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 13V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 13V11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2"
          y="3"
          width="20"
          height="18"
          rx="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Wardrobe</div>
    </div>
  );
};

export const DiningTable = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 11.5H22"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 21.5V11.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 21.5V11.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 15H9C9.55228 15 10 15.4477 10 16V17C10 17.5523 9.55228 18 9 18H3C2.44772 18 2 17.5523 2 17V8C2 7.44772 2.44772 7 3 7H4C4.55228 7 5 7.44772 5 8V15Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 19.5H21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 18V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 21.5V18"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Dining Table</div>
    </div>
  );
};

export const Reception = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 7.5H8"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 3.5H14C15.1046 3.5 16 4.39543 16 5.5V9.5C16 11.7091 14.2091 13.5 12 13.5V13.5C9.79086 13.5 8 11.7091 8 9.5V5.5C8 4.39543 8.89543 3.5 10 3.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 16L5.35 16.7297C3.98363 17.0029 3.00004 18.2025 3 19.5959L3 21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.05 17.5001C12.05 17.5277 12.0276 17.55 12 17.55C11.9724 17.55 11.95 17.5276 11.95 17.5C11.95 17.4724 11.9723 17.45 11.9999 17.45C12.0132 17.45 12.026 17.4553 12.0354 17.4646C12.0447 17.474 12.05 17.4868 12.05 17.5001"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.05 20.5001C12.05 20.5277 12.0276 20.55 12 20.55C11.9724 20.55 11.95 20.5276 11.95 20.5C11.95 20.4724 11.9723 20.45 11.9999 20.45C12.0132 20.45 12.026 20.4553 12.0354 20.4646C12.0447 20.474 12.05 20.4868 12.05 20.5001"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 16L18.65 16.7297C20.0164 17.0029 21 18.2025 21 19.5959V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Reception</div>
    </div>
  );
};

export const CityView = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.99651 4.49658H14.0007C14.5532 4.49658 15.0011 4.94448 15.0011 5.497V20.5032H3.99651C3.444 20.5032 2.99609 20.0553 2.99609 19.5028V5.497C2.99609 4.94448 3.444 4.49658 3.99651 4.49658Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.001 8.49854H20.0031C20.5556 8.49854 21.0035 8.94644 21.0035 9.49895V19.5031C21.0035 20.0556 20.5556 20.5035 20.0031 20.5035H15.001V8.49854Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99826 8.3732C6.92919 8.3732 6.8732 8.42919 6.8732 8.49826C6.8732 8.56732 6.92919 8.62331 6.99826 8.62331C7.06732 8.62331 7.12331 8.56732 7.12331 8.49826C7.12331 8.42919 7.06732 8.3732 6.99826 8.3732"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9992 8.3732C10.9302 8.3732 10.8742 8.42919 10.8742 8.49826C10.8742 8.56732 10.9302 8.62331 10.9992 8.62331C11.0683 8.62331 11.1243 8.56732 11.1243 8.49826C11.1243 8.42919 11.0683 8.3732 10.9992 8.3732"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99826 12.3752C6.92919 12.3752 6.8732 12.4311 6.8732 12.5002C6.8732 12.5693 6.92919 12.6253 6.99826 12.6253C7.06732 12.6253 7.12331 12.5693 7.12331 12.5002C7.12331 12.4311 7.06732 12.3752 6.99826 12.3752"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9992 12.3752C10.9302 12.3752 10.8742 12.4311 10.8742 12.5002C10.8742 12.5693 10.9302 12.6253 10.9992 12.6253C11.0683 12.6253 11.1243 12.5693 11.1243 12.5002C11.1243 12.4311 11.0683 12.3752 10.9992 12.3752"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99826 16.3766C6.92919 16.3766 6.8732 16.4326 6.8732 16.5017C6.8732 16.5707 6.92919 16.6267 6.99826 16.6267C7.06732 16.6267 7.12331 16.5707 7.12331 16.5017C7.12331 16.4326 7.06732 16.3766 6.99826 16.3766"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.9992 16.3766C10.9302 16.3766 10.8742 16.4326 10.8742 16.5017C10.8742 16.5707 10.9302 16.6267 10.9992 16.6267C11.0683 16.6267 11.1243 16.5707 11.1243 16.5017C11.1243 16.4326 11.0683 16.3766 10.9992 16.3766"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0022 12.3752C17.9331 12.3752 17.8771 12.4311 17.8771 12.5002C17.8771 12.5693 17.9331 12.6253 18.0022 12.6253C18.0712 12.6253 18.1272 12.5693 18.1272 12.5002C18.1272 12.4311 18.0712 12.3752 18.0022 12.3752"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0022 16.3766C17.9331 16.3766 17.8771 16.4326 17.8771 16.5017C17.8771 16.5707 17.9331 16.6267 18.0022 16.6267C18.0712 16.6267 18.1272 16.5707 18.1272 16.5017C18.1272 16.4326 18.0712 16.3766 18.0022 16.3766"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>City View</div>
    </div>
  );
};

export const SmokeDetectors = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 11.5H10.061C10.829 11.5 11.597 11.207 12.182 10.621C13.354 9.44902 13.354 7.55002 12.182 6.37802C11.01 5.20602 9.111 5.20602 7.939 6.37802"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 15.5H11.665C12.305 15.5 12.945 15.744 13.433 16.232C14.409 17.208 14.409 18.791 13.433 19.768C12.457 20.745 10.874 20.744 9.897 19.768"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 13.5H18.657C19.257 13.5 19.856 13.271 20.314 12.814C21.229 11.899 21.229 10.415 20.314 9.49997C19.399 8.58497 17.915 8.58497 17 9.49997"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Smoke Detectors</div>
    </div>
  );
};

export const MarinaView = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0012 12.0001V7.99846C15.0012 7.44595 14.5533 6.99805 14.0008 6.99805H9.99913C9.44662 6.99805 8.99872 7.44595 8.99872 7.99846V9.9993"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0008 17.0023V13.0007C14.0008 12.4481 14.4488 12.0002 15.0013 12.0002H17.0021C17.5546 12.0002 18.0025 12.4481 18.0025 13.0007V16.0019C18.0025 16.5544 17.5546 17.0023 17.0021 17.0023H6.99793C6.44541 17.0023 5.9975 16.5544 5.99738 16.0019V12.4838C5.99738 12.0145 6.26251 11.5855 6.68224 11.3757L9.1699 10.1318C9.55293 9.94033 10.0077 9.96008 10.3727 10.1841C10.7376 10.4081 10.9612 10.8046 10.9638 11.2328L10.9997 17.0023"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 6.99818V5.49756"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2.99622"
          y="2.99658"
          width="18.0075"
          height="18.0075"
          rx="5"
          stroke="#323232"
          stroke-width="1.5"
        />
      </svg>

      <div>Marina View</div>
    </div>
  );
};

export const Gym = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7139 5.5C17.2127 5.5 18.4277 8.634 18.4277 12.5C18.4277 16.366 17.2127 19.5 15.7139 19.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5361 5.5C20.8969 5.5 22 8.634 22 12.5C22 16.366 20.8969 19.5 19.5361 19.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5361 19.5H15.7139"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5361 5.5H15.7139"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.03613 5.5C9.39689 5.5 10.5 8.634 10.5 12.5C10.5 16.366 9.39689 19.5 8.03613 19.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.03611 19.5H4.46387"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.03611 5.5H4.46387"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <ellipse
          cx="4.46388"
          cy="12.5"
          rx="2.46388"
          ry="7"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4365 10.9209H14.947C15.2261 10.9209 15.4939 11.0318 15.6913 11.2292C15.8887 11.4266 15.9996 11.6944 15.9996 11.9736V13.0262C15.9996 13.3054 15.8887 13.5732 15.6913 13.7706C15.4939 13.968 15.2261 14.0789 14.947 14.0789H10.4365"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.0723 10.921C13.3502 7.81665 14.4262 5.5 15.7142 5.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.7143 19.5002C14.4263 19.5002 13.3502 17.1836 13.0723 14.0791"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Gym</div>
    </div>
  );
};

export const CarbonMonoxideDetector = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 20.5C10.7133 20.5 9.479 20.2733 8.297 19.82C7.11567 19.3653 6.04033 18.7093 5.071 17.852L5.785 17.139C6.64767 17.9117 7.613 18.4983 8.681 18.899C9.749 19.2997 10.8637 19.5 12.025 19.5C13.1737 19.5 14.281 19.304 15.347 18.912C16.4137 18.5193 17.3783 17.9427 18.241 17.182L18.948 17.872C17.9747 18.7293 16.8953 19.3817 15.71 19.829C14.5233 20.2763 13.2867 20.5 12 20.5ZM12 16.73C11.22 16.73 10.4693 16.5937 9.748 16.321C9.02667 16.0477 8.371 15.661 7.781 15.161L8.488 14.454C8.98467 14.8733 9.537 15.191 10.145 15.407C10.753 15.623 11.3777 15.731 12.019 15.731C12.6603 15.731 13.282 15.623 13.884 15.407C14.486 15.191 15.035 14.8733 15.531 14.454L16.239 15.161C15.6363 15.6743 14.9773 16.0643 14.262 16.331C13.5467 16.5977 12.7927 16.731 12 16.731M5 5.5V6.654C5 6.83333 5.05767 6.98067 5.173 7.096C5.28833 7.21133 5.436 7.269 5.616 7.269H18.385C18.5643 7.269 18.7117 7.21133 18.827 7.096C18.9423 6.98067 19 6.83333 19 6.654V5.5H5ZM7.523 8.27L8.016 9.635C8.06667 9.763 8.14333 9.86233 8.246 9.933C8.34867 10.0037 8.464 10.0387 8.592 10.038H15.408C15.536 10.038 15.6513 10.003 15.754 9.933C15.8567 9.86233 15.9333 9.76267 15.984 9.634L16.477 8.269L7.523 8.27ZM8.593 11.039C8.249 11.039 7.93733 10.9417 7.658 10.747C7.378 10.553 7.178 10.2923 7.058 9.965L6.462 8.27H5.616C5.168 8.27 4.78667 8.11267 4.472 7.798C4.15733 7.48333 4 7.102 4 6.654V4.5H20V6.654C20 7.10133 19.8427 7.48233 19.528 7.797C19.2133 8.11167 18.832 8.269 18.384 8.269H17.538L16.869 9.989C16.745 10.295 16.5483 10.5463 16.279 10.743C16.0097 10.9397 15.705 11.038 15.365 11.038L8.593 11.039Z"
          fill="#323232"
        />
      </svg>

      <div className="max-w-[150px] truncate">Carbon Monoxide Detector</div>
    </div>
  );
};

export const Hangers = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 10.0001V7.9075L13.3823 7.1395C14.0722 6.7563 14.5 6.02923 14.5 5.24012C14.4183 3.92784 13.2929 2.92743 11.9801 3.00012C10.807 2.95144 9.76537 3.7444 9.5 4.88805"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7 16.5001H17C17.5523 16.5001 18 16.9478 18 17.5001V21.0001H6V17.5001C6 16.9478 6.44772 16.5001 7 16.5001Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0002 18.0001H19.2388C20.0156 18.004 20.7018 17.4951 20.9236 16.7506C21.1453 16.0061 20.8493 15.2046 20.197 14.7828L13.4785 10.4363C12.5788 9.85472 11.4216 9.85472 10.5218 10.4363L3.8034 14.7828C3.15104 15.2046 2.85507 16.0061 3.0768 16.7506C3.29853 17.4951 3.9848 18.004 4.7616 18.0001H6.00018"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Hangers</div>
    </div>
  );
};

export const TrashCans = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.5428 21.5037H8.45698C7.28078 21.5037 6.30288 20.5981 6.21267 19.4254L5.24707 6.87256H18.7527L17.7871 19.4254C17.6969 20.5981 16.719 21.5037 15.5428 21.5037V21.5037Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.0037 6.87277H3.99707"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.18602 3.49658H14.8134C15.4349 3.49658 15.9388 4.00047 15.9388 4.62205V6.87299H8.06055V4.62205C8.06055 4.00047 8.56444 3.49658 9.18602 3.49658Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.9699 11.3745V17.0019"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.0305 11.3745V17.0019"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Trash Cans</div>
    </div>
  );
};

export const WineGlasses = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.2501 16.5L18.2499 21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.25 21.4999L20.25 21.5001"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.6832 9.5H16.8162C16.3025 9.50002 15.8723 9.88932 15.8212 10.4005L15.5137 13.4767C15.4364 14.2497 15.6897 15.0194 16.211 15.5954C16.7323 16.1714 17.4729 16.5 18.2498 16.5V16.5C19.0266 16.5 19.7673 16.1714 20.2886 15.5954C20.8098 15.0194 21.0631 14.2497 20.9859 13.4767L20.6783 10.4005C20.6272 9.8893 20.197 9.5 19.6832 9.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.44238 6.5H8.55764"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.7675 12.5H3.23242"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 17.5H3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11 14.5V19.5C11 20.6046 10.1046 21.5 9 21.5H5C3.89543 21.5 3 20.6046 3 19.5V14.5C2.99981 12.9143 3.43197 11.3585 4.25 10V10C5.06782 8.64145 5.49997 7.08572 5.5 5.5V3.5C5.5 2.94772 5.94772 2.5 6.5 2.5H7.5C8.05228 2.5 8.5 2.94772 8.5 3.5V5.5C8.49981 7.08575 8.93197 8.64154 9.75 10V10C10.5678 11.3586 11 12.9143 11 14.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Wine Glasses</div>
    </div>
  );
};

export const StreamingServiceSuchAsNetflix = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 2.5H10.5L13.44 11.33L13.5 2.5H17.5V22.5C16.25 22.28 14.87 22.14 13.41 22.08L10.5 13.5L10.43 22.09C9.03 22.15 7.7 22.29 6.5 22.5V2.5Z"
          fill="#323232"
        />
      </svg>

      <div className="max-w-[150px] truncate">
        Streaming Service Such As Netflix
      </div>
    </div>
  );
};

export const CrockeryCutlery = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 3.58398V8.04598V8.13598V8.04598C3 9.31998 3.525 10.448 4.339 11.178C4.737 11.535 5 12.017 5 12.552V20C5 20.828 5.672 21.5 6.5 21.5C7.328 21.5 8 20.828 8 20V12.552C8 12.017 8.263 11.535 8.661 11.178C9.475 10.448 10 9.31998 10 8.04598V3.58398V8.04598"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.5 8.5V3.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20 4.552C20 4 19.552 3.552 19 3.552H18C16.343 3.552 15 4.895 15 6.552V12.552C15 13.856 15.837 14.955 17 15.368V20C17 20.828 17.672 21.5 18.5 21.5C19.328 21.5 20 20.828 20 20V15.552V4.552Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Crockery & Cutlery</div>
    </div>
  );
};

export const Toilet = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 12H4.5C3.67157 12 3 11.3284 3 10.5V10.5C3 9.67157 3.67157 9 4.5 9H15"
          stroke="#202020"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 2H20C20.5523 2 21 2.44772 21 3V11C21 11.5523 20.5523 12 20 12H15V3C15 2.44772 15.4477 2 16 2Z"
          stroke="#202020"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 11V11.8377C21 13.7262 19.7916 15.4028 18 16V20C18 20.5523 17.5523 21 17 21H9.28078C8.97284 21 8.68208 20.8581 8.49257 20.6154C8.30306 20.3727 8.23594 20.0562 8.31063 19.7575L9 17L8.88057 16.9701C6.59993 16.4 5 14.3508 5 12"
          stroke="#202020"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Toilet</div>
    </div>
  );
};

export const Oven = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19.0028 21.5041H4.99693C3.8919 21.5041 2.99609 20.6083 2.99609 19.5032V5.49742C2.99609 4.39239 3.8919 3.49658 4.99693 3.49658H19.0028C20.1078 3.49658 21.0036 4.39239 21.0036 5.49742V19.5032C21.0036 20.6083 20.1078 21.5041 19.0028 21.5041Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="5.56934"
          y="12.5"
          width="12.8625"
          height="6.43125"
          rx="1"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.0036 9.49874H2.99609"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5512 6.49783C14.5512 6.52544 14.5288 6.5478 14.5012 6.54779C14.4736 6.54778 14.4512 6.5254 14.4512 6.49779C14.4512 6.47018 14.4735 6.44778 14.5011 6.44775C14.5144 6.44773 14.5272 6.453 14.5366 6.4624C14.546 6.47179 14.5512 6.48454 14.5512 6.49783"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.5522 6.49783C17.5521 6.52544 17.5298 6.5478 17.5021 6.54779C17.4745 6.54778 17.4522 6.5254 17.4521 6.49779C17.4521 6.47018 17.4745 6.44778 17.5021 6.44775C17.5154 6.44773 17.5281 6.453 17.5375 6.4624C17.5469 6.47179 17.5522 6.48454 17.5522 6.49783"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.54925 6.49783C9.54922 6.52544 9.52682 6.5478 9.49921 6.54779C9.4716 6.54778 9.44922 6.5254 9.44921 6.49779C9.4492 6.47018 9.47156 6.44778 9.49917 6.44775C9.51246 6.44773 9.52521 6.453 9.5346 6.4624C9.544 6.47179 9.54927 6.48454 9.54925 6.49783"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.54828 6.49783C6.54824 6.52544 6.52585 6.5478 6.49824 6.54779C6.47063 6.54778 6.44825 6.5254 6.44823 6.49779C6.44822 6.47018 6.47059 6.44778 6.4982 6.44775C6.51148 6.44773 6.52423 6.453 6.53363 6.4624C6.54302 6.47179 6.54829 6.48454 6.54828 6.49783"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Oven</div>
    </div>
  );
};

export const CoffeeMaker = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99826 9.49895V8.49854"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.002 11.4997H18.0024"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.002 14.5012H18.0024"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.002 17.5022H18.0024"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0007 8.49867V18.5028H3.99651C3.444 18.5028 2.99609 18.9507 2.99609 19.5032V20.5037C2.99609 21.0562 3.444 21.5041 3.99651 21.5041H19.0028C20.1078 21.5041 21.0036 20.6083 21.0036 19.5032V5.49742C21.0036 4.39239 20.1078 3.49658 19.0028 3.49658H4.99693C3.8919 3.49658 2.99609 4.39239 2.99609 5.49742V6.49783C2.99609 7.60286 3.8919 8.49867 4.99693 8.49867H14.0007Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.99749 12.5H9.99915C10.5517 12.5 10.9996 12.9479 10.9996 13.5004V15.5013C10.9996 17.1588 9.65586 18.5025 7.99832 18.5025V18.5025C6.34078 18.5025 4.99707 17.1588 4.99707 15.5013V13.5004C4.99707 12.9479 5.44497 12.5 5.99749 12.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.9979 12.5002H3.99707"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Coffee Maker</div>
    </div>
  );
};

export const ComplimentarySoapShampooConditioner = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9406 4.99754C9.00467 4.96005 7.08497 5.35761 5.32313 6.16093C2.22058 7.71223 2.22058 10.2273 5.32313 11.7786C6.48264 12.3217 7.72512 12.6662 8.99873 12.7979"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 19.0028V13.0003C12 11.3427 13.3437 9.99902 15.0013 9.99902H18.0025C19.66 9.99902 21.0037 11.3427 21.0037 13.0003V19.0028C21.0037 20.1078 20.1079 21.0036 19.0029 21.0036H14.0008C12.8958 21.0036 12 20.1078 12 19.0028Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5031 4.99749L18.7957 4.29008C18.6081 4.10247 18.3536 3.99707 18.0883 3.99707H14.501"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5019 3.99707V6.99832"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.501 7.99846C14.501 7.44595 14.9489 6.99805 15.5015 6.99805H17.5023C18.0548 6.99805 18.5027 7.44595 18.5027 7.99846V9.9993H14.501V7.99846Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99875 16.4004C7.51288 16.2468 6.06334 15.8448 4.71059 15.2112C4.28302 15.0006 3.87648 14.7496 3.49646 14.4619"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.99875 20.0039C7.51288 19.8503 6.06334 19.4484 4.71059 18.8148C4.28302 18.6041 3.87648 18.3532 3.49646 18.0654"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div className="max-w-[150px] truncate">
        Complimentary Soap/Shampoo/Conditioner
      </div>
    </div>
  );
};

export const BeachView = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 21.5H4"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.9055 4.16609V4.16609C18.7865 5.81309 20.8335 10.0931 19.6795 14.1481L19.6045 14.4131C19.2765 15.5681 18.0105 16.1731 16.9055 15.7041L5.21748 10.7421C4.11248 10.2731 3.66848 8.94209 4.27148 7.90309L4.40948 7.66409C6.52548 4.01909 11.0255 2.51809 14.9055 4.16609Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.9052 4.16602L15.1642 5.21302C15.9332 8.32802 15.2582 11.623 13.3252 14.184V14.184"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.9049 4.16602L13.9719 4.70702C11.1969 6.31702 9.2959 9.09302 8.7959 12.262V12.262"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0598 13.22L7.5498 21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Beach View</div>
    </div>
  );
};

export const Elevator = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21.5V10.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 21.5H21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 21.5V4.5C4 3.94772 4.44772 3.5 5 3.5H19C19.5523 3.5 20 3.94772 20 4.5V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 21.5V11C8 10.7239 8.22386 10.5 8.5 10.5H15.5C15.7761 10.5 16 10.7239 16 11V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 7.5L9.5 6.5L8.5 7.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5 6.5L14.5 7.5L15.5 6.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Elevator</div>
    </div>
  );
};
export const WirelessInternet = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9985 19.2501C11.7915 19.2501 11.6235 19.4181 11.6255 19.6251C11.6245 19.8321 11.7925 20.0001 11.9995 20.0001C12.2065 20.0001 12.3745 19.8321 12.3745 19.6251C12.3745 19.4181 12.2065 19.2501 11.9985 19.2501"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.58984 12.0001C8.68184 8.24711 15.3148 8.24711 19.4068 12.0001"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.59375 7.80412C7.34075 2.73212 16.6588 2.73212 22.4058 7.80412"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.57812 15.8211C10.0191 13.3931 13.9781 13.3931 16.4191 15.8211"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Wireless Internet</div>
    </div>
  );
};
export const FreeParkingWithGarage = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.60938 7.49826H12.3889"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.9993 12.5H5.99805V19.5029"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.99776 19.503H1.99609V8.06019C1.99609 7.37385 2.36834 6.7415 2.9685 6.40851L9.58225 2.73398C10.1531 2.4168 10.8472 2.4168 11.418 2.73398L18.0318 6.40851C18.6314 6.74192 19.0032 7.37412 19.0032 8.06019V9.49879"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.004 18.3026C22.004 17.1976 21.1082 16.3018 20.0032 16.3018H11.9999C10.8948 16.3018 9.99902 17.1976 9.99902 18.3026"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.99902 18.3027V21.5041C9.99902 22.0566 10.4469 22.5045 10.9994 22.5045H11.9899C12.5424 22.5045 12.9903 22.0566 12.9903 21.5041V20.8428H19.0128V21.5041C19.0128 22.0566 19.4607 22.5045 20.0132 22.5045H21.0036C21.5561 22.5045 22.004 22.0566 22.004 21.5041V18.3027"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.7378 18.6027H12.2422"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.7612 18.6027H18.2656"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.5088 16.2386L22.0044 15.4913"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.4996 16.2386L9.99902 15.4913"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5684 12.5C12.874 12.5018 12.2715 12.9797 12.1118 13.6555L11.4775 16.3666L12.1118 13.6555C12.2715 12.9797 12.874 12.5018 13.5684 12.5H18.4344C19.1288 12.5018 19.7313 12.9797 19.891 13.6555L20.5253 16.3666"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div className="max-w-[150px] truncate">Free Parking With Garage</div>
    </div>
  );
};
export const SmartTv = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22 4.49996V16.5002C22.0013 16.7811 21.8838 17.0495 21.6765 17.239C21.4692 17.4286 21.1914 17.5216 20.9117 17.4953C14.9815 16.9867 9.01856 16.9867 3.0883 17.4953C2.80863 17.5216 2.53085 17.4286 2.32353 17.239C2.11622 17.0495 1.99871 16.7811 2.00001 16.5002V4.49996C1.99871 4.21906 2.11622 3.95069 2.32353 3.76114C2.53085 3.57158 2.80863 3.4785 3.0883 3.50489C9.01856 4.01345 14.9815 4.01345 20.9117 3.50489C21.1914 3.4785 21.4692 3.57158 21.6765 3.76114C21.8838 3.95069 22.0013 4.21906 22 4.49996Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 21.5C9.57143 20.1667 14.4286 20.1667 19 21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Smart Tv</div>
    </div>
  );
};
// export const FireExtinguisher = () => {
//   return (
//     <div className="flex items-center gap-[10px]">
//       <div>Fire Extinguisher</div>
//     </div>
//   );
// };
export const Marina = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0012 12.0001V7.99846C15.0012 7.44595 14.5533 6.99805 14.0008 6.99805H9.99913C9.44662 6.99805 8.99872 7.44595 8.99872 7.99846V9.9993"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0008 17.0023V13.0007C14.0008 12.4481 14.4488 12.0002 15.0013 12.0002H17.0021C17.5546 12.0002 18.0025 12.4481 18.0025 13.0007V16.0019C18.0025 16.5544 17.5546 17.0023 17.0021 17.0023H6.99793C6.44541 17.0023 5.9975 16.5544 5.99738 16.0019V12.4838C5.99738 12.0145 6.26251 11.5855 6.68224 11.3757L9.1699 10.1318C9.55293 9.94033 10.0077 9.96008 10.3727 10.1841C10.7376 10.4081 10.9612 10.8046 10.9638 11.2328L10.9997 17.0023"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 6.99818V5.49756"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2.99622"
          y="2.99658"
          width="18.0075"
          height="18.0075"
          rx="5"
          stroke="#323232"
          stroke-width="1.5"
        />
      </svg>

      <div>Marina</div>
    </div>
  );
};
export const RoomDarkeningShades = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.82682 18.6567H6.34326C5.79097 18.6567 5.34326 18.209 5.34326 17.6567V15.1724C5.34326 14.9067 5.23772 14.6519 5.04987 14.4641L3.29287 12.7071C3.10533 12.5195 2.99997 12.2652 2.99997 12C2.99997 11.7348 3.10533 11.4804 3.29287 11.2929L5.06754 9.51825C5.24408 9.34171 5.34326 9.10226 5.34326 8.8526V6.34327C5.34326 5.79098 5.79097 5.34327 6.34326 5.34327H8.82682C9.09299 5.34325 9.34826 5.2375 9.53647 5.04927L11.2929 3.2929C11.4804 3.10536 11.7348 3 12 3C12.2652 3 12.5196 3.10536 12.7071 3.2929L14.4635 5.04932C14.6517 5.23755 14.907 5.3433 15.1732 5.34332H17.6567C18.209 5.34332 18.6567 5.79103 18.6567 6.34332V8.82761C18.6567 9.09327 18.7623 9.34806 18.9501 9.53592L20.7071 11.2929C20.8947 11.4805 21 11.7348 21 12C21 12.2652 20.8947 12.5196 20.7071 12.7071L18.9507 14.4636C18.7625 14.6518 18.6568 14.907 18.6568 15.1732V17.6568C18.6568 18.2091 18.209 18.6568 17.6568 18.6568H15.1724C14.9067 18.6568 14.6519 18.7623 14.4641 18.9502L12.7071 20.7072C12.5195 20.8947 12.2652 21.0001 12 21.0001C11.7347 21.0001 11.4804 20.8947 11.2929 20.7072L9.53647 18.9507C9.34826 18.7625 9.09299 18.6567 8.82682 18.6567Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8V16Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Room Darkening Shades</div>
    </div>
  );
};
export const IronIroningBoard = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 7.5H12C13.1046 7.5 14 8.39543 14 9.5V19.5C14 20.6046 13.1046 21.5 12 21.5H4C2.89543 21.5 2 20.6046 2 19.5V9.5C2 8.39543 2.89543 7.5 4 7.5H6L5.79487 6.03554C5.70547 5.39734 5.89696 4.75171 6.31985 4.26545C6.74275 3.77919 7.35557 3.5 8 3.5V3.5C8.64443 3.5 9.25725 3.77919 9.68015 4.26545C10.103 4.75171 10.2945 5.39734 10.2051 6.03554L10 7.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.9885 14.3085L22 15.5H17.5C17.2239 15.5 17 15.2761 17 15V11.8142C17 7.22239 19.2334 3.5 21.9885 3.5L22 3.51148L21.9908 3.5V15.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M19 15.5H22V20C22 20.8284 21.3284 21.5 20.5 21.5V21.5C19.6716 21.5 19 20.8284 19 20V15.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Iron & Ironing Board</div>
    </div>
  );
};

export const BedLinenTowels = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 21H4"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7 7H17C18.1046 7 19 7.89543 19 9V15H5V9C5 7.89543 5.89543 7 7 7Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="19"
          y="12"
          width="4"
          height="9"
          rx="1"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="1"
          y="12"
          width="4"
          height="9"
          rx="1"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Bed Linen & Towels</div>
    </div>
  );
};

export const Kettle = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.99666 8.65861L3.54854 7.31427C3.44684 7.00918 3.49801 6.67382 3.68605 6.41294C3.87409 6.15206 4.17608 5.9975 4.49766 5.9975H17.0021V19.0029C17.0021 20.1079 16.1063 21.0037 15.0012 21.0037H5.9975C4.89247 21.0037 3.99666 20.1079 3.99666 19.0029V8.65861Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.0021 15.3834V5.9975H19.0029C20.1079 5.9975 21.0037 6.8933 21.0037 7.99833V13.7647C21.0037 14.5225 20.5756 15.2153 19.8977 15.5543L18.4499 16.2782C18.1398 16.4332 17.7715 16.4167 17.4766 16.2344C17.1816 16.0521 17.0021 15.7301 17.0021 15.3834Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.8385 2.99625H8.16067C6.86884 2.99625 5.72194 3.82288 5.31343 5.04842L4.99707 5.9975H17.0021L16.6857 5.04842C16.2772 3.82288 15.1303 2.99625 13.8385 2.99625Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="8.99875"
          y="8.99875"
          width="3.00125"
          height="9.00375"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 14.0008H8.99875"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Kettle</div>
    </div>
  );
};

export const Microwave = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 17.068V6.932C3 5.865 3.865 5 4.932 5H19.068C20.135 5 21 5.865 21 6.932V17.068C21 18.135 20.135 19 19.068 19H4.932C3.865 19 3 18.135 3 17.068Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 5V19"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 10V14"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 19V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 19V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Microwave</div>
    </div>
  );
};

export const AirConditioning = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.346 5H5.654C5.025 5 4.5 5.525 4.5 6.154V11.924C4.5 12.552 5.025 13.077 5.654 13.077H18.346C18.975 13.077 19.5 12.552 19.5 11.923V6.153C19.5 5.525 18.975 5 18.346 5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.6146 13.0772V10.7692C16.6146 10.1412 16.0896 9.61523 15.4616 9.61523H8.53664C7.90864 9.61523 7.38364 10.1412 7.38364 10.7692V13.0772M6.80664 18.8472C8.44664 18.8472 8.53664 17.2432 8.53664 15.9612M17.1906 18.8462C15.5506 18.8462 15.4606 17.2432 15.4606 15.9612M11.9996 20.0002V15.9612"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Air Conditioning</div>
    </div>
  );
};

export const Seaview = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 11.5V6.5C3 5.94772 3.44772 5.5 4 5.5H8C8.55228 5.5 9 5.94772 9 6.5V8.2929C9 8.42551 8.94732 8.55269 8.85355 8.64646L8.14645 9.35356C8.05268 9.44733 8 9.57451 8 9.70712V11.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 5.5V3.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 11.5V4.5C12 3.94772 12.4477 3.5 13 3.5H20C20.5523 3.5 21 3.94772 21 4.5V9.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.8646 14.5L21.8668 10.9961C22.0436 10.6866 22.0423 10.3064 21.8634 9.99807C21.6845 9.68977 21.355 9.50002 20.9986 9.5H16.302C15.9432 9.5 15.6118 9.69227 15.4338 10.0038L14.8667 10.9962C14.6886 11.3077 14.3573 11.5 13.9985 11.5H3C2.44772 11.5 2 11.9477 2 12.5V14.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 18C4.17685 17.6667 5.42315 17.6667 6.6 18C7.77685 18.3333 9.02315 18.3333 10.2 18C11.3769 17.6667 12.6231 17.6667 13.8 18C14.9769 18.3333 16.2231 18.3333 17.4 18C18.5769 17.6667 19.8231 17.6667 21 18"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.59961 21.25C7.77646 21.5833 9.02276 21.5833 10.1996 21.25C11.3765 20.9167 12.6228 20.9167 13.7996 21.25C14.9765 21.5833 16.2228 21.5833 17.3996 21.25"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Seaview</div>
    </div>
  );
};

export const Beach = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 21.5H4"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.9055 4.16609V4.16609C18.7865 5.81309 20.8335 10.0931 19.6795 14.1481L19.6045 14.4131C19.2765 15.5681 18.0105 16.1731 16.9055 15.7041L5.21748 10.7421C4.11248 10.2731 3.66848 8.94209 4.27148 7.90309L4.40948 7.66409C6.52548 4.01909 11.0255 2.51809 14.9055 4.16609Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.9052 4.16602L15.1642 5.21302C15.9332 8.32802 15.2582 11.623 13.3252 14.184V14.184"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.9049 4.16602L13.9719 4.70702C11.1969 6.31702 9.2959 9.09302 8.7959 12.262V12.262"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0598 13.22L7.5498 21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Beach</div>
    </div>
  );
};
export const PlayGround = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 21.5V6.60002C14 5.89749 13.6314 5.24647 13.029 4.88502L9.529 2.78502C8.89563 2.40499 8.10437 2.40499 7.471 2.78502L3.971 4.88502C3.36859 5.24647 2.99999 5.89749 3 6.60002V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 16H11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 19.5H11"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle
          cx="8.5"
          cy="8"
          r="2"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 12.5V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 12.5V21.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 21.5H21.2997C20.5094 21.5 19.7931 21.0345 19.4721 20.3123L16.5279 13.6877C16.2069 12.9655 15.4906 12.5 14.7002 12.5H3"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Play Ground</div>
    </div>
  );
};

export const Refrigerator = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.25 21.5H6.75C5.645 21.5 4.75 20.605 4.75 19.5V4.5C4.75 3.395 5.645 2.5 6.75 2.5H17.25C18.355 2.5 19.25 3.395 19.25 4.5V19.5C19.25 20.605 18.355 21.5 17.25 21.5Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.25 11.6101H4.75"
          stroke="#323232"
          stroke-width="1.5157"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 6.5V8.5"
          stroke="#323232"
          stroke-width="1.5157"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 14.5V16.5"
          stroke="#323232"
          stroke-width="1.5157"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Refrigerator</div>
    </div>
  );
};

export const FamilyKidsFriendly = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8906 11.3525C15.6115 11.7168 15.1819 11.9344 14.7231 11.9438C14.2653 11.9318 13.837 11.7147 13.5566 11.3525"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.4433 11.3525C10.1645 11.7165 9.73531 11.9341 9.27686 11.9438C8.81871 11.9318 8.39014 11.7148 8.10938 11.3525"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 20.8366C15.7544 20.8348 19.0441 18.3226 20.0343 14.701C21.156 14.5788 22.0058 13.6315 22.0058 12.5031C22.0058 11.3747 21.156 10.4274 20.0343 10.3052C19.0466 6.6817 15.7557 4.16772 12 4.16772C8.24424 4.16772 4.95329 6.6817 3.96561 10.3052C2.84386 10.4274 1.99414 11.3747 1.99414 12.5031C1.99414 13.6315 2.84386 14.5788 3.96561 14.701C4.95583 18.3226 8.24549 20.8348 12 20.8366Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.2232 15.5083C12.9495 16.6195 11.051 16.6195 9.77734 15.5083"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.8887 7.68904C11.2116 7.92458 11.6005 8.05235 12.0001 8.05419C13.0573 8.03022 13.9018 7.16634 13.9018 6.10888C13.9018 5.05143 13.0573 4.18755 12.0001 4.16357"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Family/Kids Friendly</div>
    </div>
  );
};

export const NoParties = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5359 20.0354L4.46484 4.96436"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="3"
          y="3.5"
          width="18"
          height="18"
          rx="5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>No Parties</div>
    </div>
  );
};

export const Essentials = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.49771 8.9993V5.99805"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.4998 8.9993V5.99805"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.99707 4.49672V5.49714C4.99707 5.77339 5.22102 5.99734 5.49728 5.99734H12.5002C12.7765 5.99734 13.0004 5.77339 13.0004 5.49714V2.99609H6.4977C5.66892 2.99609 4.99707 3.66795 4.99707 4.49672Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0008 13.0007V10.4996C14.0008 9.67088 13.329 8.99902 12.5002 8.99902H5.4973C4.66853 8.99902 3.99667 9.67088 3.99667 10.4996V19.5034C3.99667 20.3322 4.66853 21.004 5.4973 21.004H8.99876"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.0013 2.9963H13.0004"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.5023 18.0026C18.6073 18.0026 19.5031 17.1068 19.5031 16.0018C19.5031 14.8968 18.6073 14.001 17.5023 14.001C17.5023 14.8297 16.6065 15.5016 15.5015 15.5016H14.7511C14.0605 15.5016 13.5006 16.0615 13.5006 16.7521C13.5006 17.4428 14.0605 18.0026 14.7511 18.0026H13.5006C12.6719 18.0026 12 18.6745 12 19.5033V19.5033C12 20.332 12.6719 21.0039 13.5006 21.0039H19.5031C20.3319 21.0039 21.0037 20.332 21.0037 19.5033V19.5033C21.0037 18.6745 20.3319 18.0026 19.5031 18.0026H17.5023Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div className="max-w-[150px] truncate">
        Essentials (Towels, Pillows, Bed Linen, Soap, Toilet Paper)
      </div>
    </div>
  );
};

export const CleaningProducts = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.49853 22.0042V20.0033"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.5015 22.0042V20.0033"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.767 22.0042H7.23301C6.66382 22.0042 6.12154 21.7619 5.74192 21.3378C5.3623 20.9137 5.18129 20.3479 5.24418 19.7822L5.60233 16.5599C5.82761 14.5336 7.54024 13.0007 9.57899 13.0004H14.421C16.4617 12.9981 18.1772 14.5317 18.4027 16.5599L18.7608 19.7822C18.8238 20.3488 18.6421 20.9154 18.2614 21.3396C17.8807 21.7639 17.337 22.0057 16.767 22.0042V22.0042Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 1.99583V1.99583C12.8288 1.99583 13.5006 2.66768 13.5006 3.49646V9.49896C13.5006 9.77521 13.2767 9.99916 13.0004 9.99916H10.9996C10.7233 9.99916 10.4994 9.77521 10.4994 9.49896V3.49646C10.4994 2.66768 11.1712 1.99583 12 1.99583Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.2509 13.0004H9.74905C9.41447 13.0004 9.10203 12.8332 8.91648 12.5548C8.73094 12.2764 8.69686 11.9236 8.82567 11.6148L9.24284 10.6144C9.39829 10.2418 9.76248 9.99913 10.1662 9.99916H13.8338C14.2375 9.99913 14.6017 10.2418 14.7571 10.6144L15.1743 11.6148C15.3031 11.9236 15.269 12.2764 15.0835 12.5548C14.898 12.8332 14.5855 13.0004 14.2509 13.0004V13.0004Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 22.0042V20.0033"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Cleaning Products</div>
    </div>
  );
};

export const FirstAidKit = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 5C19 3.89543 18.1046 3 17 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H9"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 7.5V5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.25 13V11.5C19.25 10.9477 18.8023 10.5 18.25 10.5H15.75C15.1977 10.5 14.75 10.9477 14.75 11.5V13"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 8H12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 12H9"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7 16H8"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="12"
          y="13.5"
          width="10"
          height="7.5"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 17.25H18.25"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 18.5V16"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="12"
          y="13.5"
          width="10"
          height="7.5"
          rx="1.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>First Aid Kit</div>
    </div>
  );
};

export const CookingBasics = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.30953 8.59599L3.58578 11.3198C2.80474 12.1008 2.80474 13.3672 3.58578 14.1482L9.85178 20.4142C10.6328 21.1952 11.8992 21.1952 12.6802 20.4142L16.0412 17.0532"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.503 12.497L12 16L9.36562 13.3965C6.08368 10.153 5.01947 5.94608 6.98863 4H7L19.5836 16.5748C19.8502 16.8411 20 17.2025 20 17.5793C20 17.9562 19.8502 18.3176 19.5836 18.5839V18.5839C19.0283 19.1387 18.1284 19.1387 17.5731 18.5839L13.493 14.507"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0511 15.0433L20.4142 12.6802C21.1953 11.8992 21.1953 10.6328 20.4142 9.85179L14.1482 3.58579C13.3672 2.80475 12.1008 2.80475 11.3198 3.58579L8.95348 5.9521"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.7986 8.23617L20.0506 7.29185C20.602 6.87593 20.9462 6.24151 20.9942 5.55249C21.0422 4.86347 20.7894 4.18744 20.301 3.69905V3.69905C19.8126 3.21066 19.1366 2.95781 18.4476 3.00584C17.7585 3.05386 17.1241 3.39804 16.7082 3.94946L15.7639 5.20146"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Cooking Basics</div>
    </div>
  );
};

export const SmokingNotAllowed = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5359 20.0354L4.46484 4.96436"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11 11.5H17C17.2761 11.5 17.5 11.7239 17.5 12V14C17.5 14.2761 17.2761 14.5 17 14.5H14"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="3"
          y="3.5"
          width="18"
          height="18"
          rx="5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5 6V6.025C13.507 6.8465 14.1785 7.50684 15 7.5V7.5C15.8215 7.49316 16.493 8.1535 16.5 8.975V9"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.5 14.5H7C6.72386 14.5 6.5 14.2761 6.5 14V12C6.5 11.7239 6.72386 11.5 7 11.5H7.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Smoking Not Allowed</div>
    </div>
  );
};
